export default {"src":"/planos/_next/static/media/score-pointer.4fc466d9.svg","height":92,"width":32,"blurWidth":0,"blurHeight":0};